export default [
    {
        name: "name",
        label: "Name",
        type: "string",
    },
    // {
    //     name: "driverIds",
    //     label: "Drivers",
    //     type: "list",
    //     helpText: "Drivers",
    //     url: "/drivers",
    //     filterValue: "name",
    //     entityName: "drivers",
    //     include: true,
    // },
    // {
    //     name: "truckIds",
    //     label: "Trucks",
    //     type: "list",
    //     helpText: "Trucks",
    //     url: "/trucks",
    //     filterValue: "plateNumber",
    //     entityName: "trucks",
    //     include: true,
    // },
];
